import React from "react";

import * as S from "./error-message.styled";

export const ErrorMessage: React.FC = ({ children }) => <S.ErrorMessage>{children}</S.ErrorMessage>;
